import React from 'react'
import OrganisationViewTab from './child/OrganisationViewTab'


const OrganisationViewLayer = () => {
    return (
        <div className="">
            <OrganisationViewTab />
        </div>

    )
}

export default OrganisationViewLayer;